module.exports = __webpack_public_path__ + "cancellara-dist/img/fiamm.fabe4f96.png";